export const aboutData = {
  heading: "About Me",
  description: [
    "I'm a software engineer focused on building clean, scalable web applications with modern JavaScript frameworks. I work primarily with React, TypeScript, and Node.js, and I enjoy designing well-structured frontends backed by reliable APIs.",
    "My experience includes authentication systems, RESTful API design, database modeling with MongoDB, and automated testing using tools like Playwright, Jest, and NUnit.",
    "I value maintainable code, clear architecture, and practical solutions over unnecessary complexity. I'm continuously improving my skills, exploring better developer workflows, and building projects that balance performance, usability, and simplicity."
  ],
  highlights: [
    { label: "Performance Focused", icon: "⚡" },
    { label: "Scalable Systems", icon: "📈" },
    { label: "Clean Architecture", icon: "🏗️" },
    { label: "API Design", icon: "🔗" },
    { label: "Test-Driven Development", icon: "✅" },
    { label: "CI/CD Pipelines", icon: "🔄" },
    { label: "Database Modeling", icon: "🗄️" },
    { label: "Responsive Design", icon: "📱" }
  ],
};
